function state() {
  return {
    gadgets: [],
    gadgetsMeta: {},
    // this is used for lazy loading
    gadgetsAll: [],
    policies: [],
    policiesMeta: {},
    // this is used for lazy loading
    policiesAll: [],
    policy: {},
    claims: [],
    claimsMeta: {},
    // this is used for lazy loading
    claimsAll: [],
    claim: {},
    partners: [],
    products: [],
    productCategories: [],
    uploadProgress: 0,
    createPolicy: {},
    createClaim: [],
    questionCostEstimation: [],
    filesCostEstimation: [],
    extractImei: "",
    paymentMethod: {},
    isValidCreateClaim: {},
    gadgetCategory: [],
    productService: [],
    productServiceBuybackProgram: false,
    listBrand: [],
    listType: [],
    agentList: {},
    editPolicyHistory: [],
    claimsHistoriesClaim: {},
    serviceCenters: {},
  };
}

export default state;
